import { render, staticRenderFns } from "./NewProjectScopingStarted.vue?vue&type=template&id=dd1c799e&scoped=true"
import script from "./NewProjectScopingStarted.vue?vue&type=script&lang=js"
export * from "./NewProjectScopingStarted.vue?vue&type=script&lang=js"
import style0 from "./NewProjectScopingStarted.vue?vue&type=style&index=0&id=dd1c799e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1c799e",
  null
  
)

export default component.exports